const truthyValues = [1, 'True'];
//const falsyValues = [0, 'false'];

const getDateRanges = (ranges, delimiter = '-') => {
  return (ranges || '')
    .toString()
    .split(';')
    .reduce(
      (acc, item) => {
        if (item) {
          const date = item.split(delimiter);
          acc.from.push((date[0] || '').trim());
          acc.to.push((date[1] || '').trim());
        }
        return acc;
      },
      { from: [], to: [] }
    );
};
export const getUploadRuleObj = rule => {
  let req = {
    enabled: truthyValues.includes(rule['Enabled']) ? true : false, //default is true
    ...(rule['RuleID'] !== 'business-hours-rule' &&
      rule['RuleID'] !== 'after-hours-rule' && { type: 'Custom' }), //not defaulted to Custom if the rule type is business hours or after hours
    name: rule['Name'], //required
  };

  //**Search through all the options and add the specified field(s) to the req object**
  //1) Callers
  if (rule['Callers-callerId'] || rule['Callers-name']) {
    const callerIds = (rule['Callers-callerId'] || '').toString().split(',');
    const callerNames = (rule['Callers-name'] || '').toString().split(',');
    if (callerIds.length === callerNames.length && callerNames.length) {
      req.callers = callerIds.map((id, index) => {
        return {
          callerId: id,
          name: callerNames[index],
        };
      });
    }
  }

  //2) Called Numbers
  if (rule['CalledNumbers-phoneNumber']) {
    const phoneNumbers = rule['CalledNumbers-phoneNumber']
      .toString()
      .split(',');
    req.calledNumbers = phoneNumbers.map(number => {
      return {
        phoneNumber: number,
      };
    });
  }

  //3) Schedule (weekly, range, or ref)
  if (
    rule['Schedule-WeeklyRanges-Monday'] ||
    rule['Schedule-WeeklyRanges-Tuesday'] ||
    rule['Schedule-WeeklyRanges-Wednesday'] ||
    rule['Schedule-WeeklyRanges-Thursday'] ||
    rule['Schedule-WeeklyRanges-Friday'] ||
    rule['Schedule-WeeklyRanges-Saturday'] ||
    rule['Schedule-WeeklyRanges-Sunday']
  ) {
    const { from: mondayFromRules, to: mondayToRules } = getDateRanges(
      rule['Schedule-WeeklyRanges-Monday']
    );
    const { from: tuesdayFromRules, to: tuesdayToRules } = getDateRanges(
      rule['Schedule-WeeklyRanges-Tuesday']
    );
    const { from: wednesdayFromRules, to: wednesdayToRules } = getDateRanges(
      rule['Schedule-WeeklyRanges-Wednesday']
    );
    const { from: thursdayFromRules, to: thursdayToRules } = getDateRanges(
      rule['Schedule-WeeklyRanges-Thursday']
    );
    const { from: fridayFromRules, to: fridayToRules } = getDateRanges(
      rule['Schedule-WeeklyRanges-Friday']
    );
    const { from: saturdayFromRules, to: saturdayToRules } = getDateRanges(
      rule['Schedule-WeeklyRanges-Saturday']
    );
    const { from: sundayFromRules, to: sundayToRules } = getDateRanges(
      rule['Schedule-WeeklyRanges-Sunday']
    );

    req.schedule = { weeklyRanges: {} };
    if (
      mondayFromRules.length === mondayToRules.length &&
      mondayToRules.length
    ) {
      req.schedule.weeklyRanges.monday = mondayFromRules.map((rule, index) => {
        return {
          from: mondayFromRules[index],
          to: mondayToRules[index],
        };
      });
    }

    if (
      tuesdayFromRules.length === tuesdayToRules.length &&
      tuesdayToRules.length
    ) {
      req.schedule.weeklyRanges.tuesday = tuesdayFromRules.map(
        (rule, index) => {
          return {
            from: tuesdayFromRules[index],
            to: tuesdayToRules[index],
          };
        }
      );
    }

    if (
      wednesdayFromRules.length === wednesdayToRules.length &&
      wednesdayToRules.length
    ) {
      req.schedule.weeklyRanges.wednesday = wednesdayFromRules.map(
        (rule, index) => {
          return {
            from: wednesdayFromRules[index],
            to: wednesdayToRules[index],
          };
        }
      );
    }

    if (
      thursdayFromRules.length === thursdayToRules.length &&
      thursdayToRules.length
    ) {
      req.schedule.weeklyRanges.thursday = thursdayFromRules.map(
        (rule, index) => {
          return {
            from: thursdayFromRules[index],
            to: thursdayToRules[index],
          };
        }
      );
    }

    if (
      fridayFromRules.length === fridayToRules.length &&
      fridayToRules.length
    ) {
      req.schedule.weeklyRanges.friday = fridayFromRules.map((rule, index) => {
        return {
          from: fridayFromRules[index],
          to: fridayToRules[index],
        };
      });
    }

    if (
      saturdayFromRules.length === saturdayToRules.length &&
      saturdayToRules.length
    ) {
      req.schedule.weeklyRanges.saturday = saturdayFromRules.map(
        (rule, index) => {
          return {
            from: saturdayFromRules[index],
            to: saturdayToRules[index],
          };
        }
      );
    }

    if (
      sundayFromRules.length === sundayToRules.length &&
      sundayToRules.length
    ) {
      req.schedule.weeklyRanges.sunday = sundayFromRules.map((rule, index) => {
        return {
          from: sundayFromRules[index],
          to: sundayToRules[index],
        };
      });
    }

    if (
      !req.schedule.weeklyRanges.monday &&
      !req.schedule.weeklyRanges.tuesday &&
      !req.schedule.weeklyRanges.wednesday &&
      !req.schedule.weeklyRanges.thursday &&
      !req.schedule.weeklyRanges.friday &&
      !req.schedule.weeklyRanges.saturday &&
      !req.schedule.weeklyRanges.sunday
    ) {
      delete req.schedule.weeklyRanges;
    }
  } else if (rule['Schedule-Ranges']) {
    const { from, to } = getDateRanges(rule['Schedule-Ranges'], ' - ');
    if (from.length === to.length && to.length) {
      req.schedule = {
        ranges: from.map((rule, index) => {
          return {
            from: from[index],
            to: to[index],
          };
        }),
      };
    }
  } else if (rule['Schedule-Ref']) {
    req.schedule = {
      ref: rule['Schedule-Ref'],
    };
  }

  //4) Call handling action:
  if (rule['CallHandlingAction']) {
    req.callHandlingAction = rule['CallHandlingAction'];
  }

  //5) Unconditional Forwarding:
  if (rule['Unconditional Forwarding-phoneNumber']) {
    req.unconditionalForwarding = {
      phoneNumber: rule['Unconditional Forwarding-phoneNumber'],
    };
  }

  //6) Forwarding:
  if (
    rule['Forwarding-notifyMySoftPhones'] ||
    rule['Forwarding-notifyAdminSoftPhone'] ||
    rule['Forwarding-softPhonesRingCount'] ||
    rule['Forwarding-ringingMode'] ||
    rule['Forwarding-mobileTimeout'] ||
    rule['Forwarding-Rules-index'] ||
    rule['Forwarding-Rules-ringCount'] ||
    rule['Forwarding-Rules-enabled'] ||
    rule['Forwarding-Rules-ForwardingNumbers-uri'] ||
    rule['Forwarding-Rules-ForwardingNumbers-id'] ||
    rule['Forwarding-Rules-ForwardingNumbers-phoneNumber']
  ) {
    req.forwarding = {};

    if (rule['Forwarding-notifyMySoftPhones'] !== '') {
      req.forwarding.notifyMySoftPhones = truthyValues.includes(
        rule['Forwarding-notifyMySoftPhones']?.toLowerCase()
      )
        ? true
        : false;
    }
    if (rule['Forwarding-notifyAdminSoftPhone'] !== '') {
      req.forwarding.notifyAdminSoftPhones = truthyValues.includes(
        rule['Forwarding-notifyAdminSoftPhone']?.toLowerCase()
      )
        ? true
        : false;
    }
    if (rule['Forwarding-softPhonesRingCount']) {
      req.forwarding.softPhonesRingCount =
        rule['Forwarding-softPhonesRingCount'];
    }
    if (rule['Forwarding-ringingMode']) {
      req.forwarding.ringingMode = rule['Forwarding-ringingMode'];
    }
    if (rule['Forwarding-mobileTimeout'] !== '') {
      req.forwarding.mobileTimeout = truthyValues.includes(
        rule['Forwarding-mobileTimeout']?.toLowerCase()
      )
        ? true
        : false;
    }
    if (
      rule['Forwarding-Rules-index'] ||
      rule['Forwarding-Rules-ringCount'] ||
      rule['Forwarding-Rules-enabled']
    ) {
      const rulesIndex = (rule['Forwarding-Rules-index'] || '')
        .toString()
        .split(',');
      const rulesRingCount = (rule['Forwarding-Rules-ringCount'] || '')
        .toString()
        .split(',');
      const rulesEnabled = rule['Forwarding-Rules-enabled']
        ?.toString()
        ?.split(',');
      if (
        rulesIndex.length === rulesRingCount.length &&
        rulesRingCount.length === rulesEnabled.length &&
        rulesIndex.length
      ) {
        req.forwarding.rules = rulesIndex.map((datum, index) => {
          let forwardingRuleObj = {
            index: rulesIndex[index],
            ringCount: rulesRingCount[index],
            enabled: truthyValues.includes(rulesEnabled[index]) ? true : false,
          };
          if (rule['Forwarding-Rules-ForwardingNumbers-uri']) {
            const forwardingRuleAllForwaringUris = (
              rule['Forwarding-Rules-ForwardingNumbers-uri'] || ''
            )
              .toString()
              .split(',');
            const forwardingRuleAllForwaringIds = (
              rule['Forwarding-Rules-ForwardingNumbers-id'] || ''
            )
              .toString()
              .split(',');
            const forwardingRuleAllForwaringPhones = (
              rule['Forwarding-Rules-ForwardingNumbers-phoneNumber'] || ''
            )
              .toString()
              .split(',');
            const forwardingRuleAllForwaringLabel = (
              rule['Forwarding-Rules-ForwardingNumbers-label'] || ''
            )
              .toString()
              .split(',');
            const forwardingRuleAllForwaringTypes = (
              rule['Forwarding-Rules-ForwardingNumbers-type'] || ''
            )
              .toString()
              .split(',');

            if (
              forwardingRuleAllForwaringUris[index] &&
              forwardingRuleAllForwaringIds[index] &&
              forwardingRuleAllForwaringPhones[index] &&
              forwardingRuleAllForwaringLabel[index] &&
              forwardingRuleAllForwaringTypes[index]
            ) {
              const uris = forwardingRuleAllForwaringUris[index].split(';');
              const ids = forwardingRuleAllForwaringIds[index].split(';');
              const phones = forwardingRuleAllForwaringPhones[index].split(';');
              const labels = forwardingRuleAllForwaringLabel[index].split(';');
              const types = forwardingRuleAllForwaringTypes[index].split(';');

              if (
                uris.length &&
                uris.length === ids.length &&
                ids.length === phones.length &&
                phones.length === labels.length &&
                labels.length === types.length
              ) {
                forwardingRuleObj.forwardingNumbers = uris.map(
                  (item, itemIndex) => {
                    return {
                      id: ids[itemIndex],
                      uri: uris[itemIndex],
                      phoneNumber: phones[itemIndex],
                      label: labels[itemIndex],
                      type: types[index],
                    };
                  }
                );
              }
            }
          }
          return forwardingRuleObj;
        });
      }
    }
  } else {
    delete req.forwarding;
  }

  //7) Queue
  if (
    rule['Queue-transferMode'] ||
    rule['Queue-holdAudioInterruptionMode'] ||
    rule['Queue-holdAudioInterruptionPeriod'] ||
    rule['Queue-agentTimeout'] ||
    rule['Queue-wrapUpTime'] ||
    rule['Queue-holdTime'] ||
    rule['Queue-maxCallers'] ||
    rule['Queue-maxCallersAction'] ||
    rule['Queue-FixedOrderAgents-Index'] ||
    rule['Queue-FixedOrderAgents-Extension-id'] ||
    rule['Queue-FixedOrderAgents-Extension-uri'] ||
    rule['Queue-FixedOrderAgents-Extension-extensionNumber'] ||
    rule['Queue-FixedOrderAgents-Extension-partnerId']
  ) {
    req.queue = {};

    if (rule['Queue-transferMode']) {
      req.queue.transferMode = rule['Queue-transferMode'];
    }
    if (rule['Queue-holdAudioInterruptionMode']) {
      req.queue.holdAudioInterruptionMode =
        rule['Queue-holdAudioInterruptionMode'];
    }
    if (rule['Queue-holdAudioInterruptionPeriod']) {
      req.queue.holdAudioInterruptionPeriod =
        rule['Queue-holdAudioInterruptionPeriod'];
    }
    if (rule['Queue-agentTimeout']) {
      req.queue.agentTimeout = rule['Queue-agentTimeout'];
    }
    if (rule['Queue-wrapUpTime']) {
      req.queue.wrapUpTime = rule['Queue-wrapUpTime'];
    }
    if (rule['Queue-holdTime']) {
      req.queue.holdTime = rule['Queue-holdTime'];
    }
    if (rule['Queue-maxCallers']) {
      req.queue.maxCallers = rule['Queue-maxCallers'];
    }
    if (rule['Queue-maxCallersAction']) {
      req.queue.maxCallersAction = rule['Queue-maxCallersAction'];
    }

    if (
      rule['Queue-FixedOrderAgents-Index'] ||
      rule['Queue-FixedOrderAgents-Extension-id'] ||
      rule['Queue-FixedOrderAgents-Extension-uri'] ||
      rule['Queue-FixedOrderAgents-Extension-extensionNumber'] ||
      rule['Queue-FixedOrderAgents-Extension-partnerId']
    ) {
      const queueIndex = (rule['Queue-FixedOrderAgents-Index'] || '')
        .toString()
        .split(',');
      const queueExtensionId = (
        rule['Queue-FixedOrderAgents-Extension-id'] || ''
      )
        .toString()
        .split(',');
      const queueExtensionUri = (
        rule['Queue-FixedOrderAgents-Extension-uri'] || ''
      )
        .toString()
        .split(',');
      const queueExtensionNumber = (
        rule['Queue-FixedOrderAgents-Extension-extensionNumber'] || ''
      )
        .toString()
        .split(',');
      const queueExtensionPartnerId = (
        rule['Queue-FixedOrderAgents-Extension-partnerId'] || ''
      )
        .toString()
        .split(',');

      if (
        queueIndex.length === queueExtensionId.length &&
        queueExtensionId.length === queueExtensionUri.length &&
        queueExtensionUri.length === queueExtensionNumber.length &&
        queueExtensionNumber.length === queueExtensionPartnerId.length &&
        queueExtensionPartnerId.length
      ) {
        req.queue.fixedOrderAgents = queueIndex.map((queue, index) => {
          return {
            index: queueIndex[index],
            extension: {
              id: queueExtensionId[index],
              uri: queueExtensionUri[index],
              extensionNumber: queueExtensionNumber[index],
              partnerId: queueExtensionPartnerId[index],
            },
          };
        });
      }
    }
  }

  //8) Transfer:
  if (rule['Transfer-Extension-id']) {
    req.transfer = {
      extension: {
        id: rule['Transfer-Extension-id'],
      },
    };
    if (rule['Transfer-Extension-uri']) {
      req.transfer.extension.uri = rule['Transfer-Extension-uri'];
    }
    if (rule['Transfer-Extension-extensionNumber']) {
      req.transfer.extension.extensionNumber =
        rule['Transfer-Extension-extensionNumber'];
    }
    if (rule['Transfer-Extension-partnerId']) {
      req.transfer.extension.partnerId = rule['Transfer-Extension-partnerId'];
    }
  }

  //9) Voicemail
  if (rule['Voicemail-Enabled'] !== '') {
    req.voicemail = {
      enabled: truthyValues.includes(
        (rule['Voicemail-Enabled'] || '')?.toString().toLowerCase()
      )
        ? true
        : false,
    };

    if (rule['Voicemail-Recipient-id'] || rule['Voicemail-Recipient-uri']) {
      req.voicemail.recipient = {};

      if (rule['Voicemail-Recipient-id']) {
        req.voicemail.recipient.id = rule['Voicemail-Recipient-id'];
      }
      if (rule['Voicemail-Recipient-uri']) {
        req.voicemail.recipient.uri = rule['Voicemail-Recipient-uri'];
      }
    }
  } else {
    delete rule.voicemail;
  }

  //11) Screening
  if (rule['Screening'] !== '') {
    req.screening = rule['Screening'];
  }

  //12) Greetings
  if (
    rule['Greetings-Type'] ||
    rule['Greetings-Preset-uri'] ||
    rule['Greetings-Preset-id'] ||
    rule['Greetings-Preset-name']
  ) {
    const greetingsTypes = (rule['Greetings-Type'] || '').toString().split(',');
    const greetingsPresetUris = (rule['Greetings-Preset-uri'] || '')
      .toString()
      .split(',');
    const greetingsPresetIds = (rule['Greetings-Preset-id'] || '')
      .toString()
      .split(',');
    const greetingsPresetNames = (rule['Greetings-Preset-name'] || '')
      .toString()
      .split(',');

    if (
      greetingsTypes.length === greetingsPresetUris.length &&
      greetingsPresetUris.length === greetingsPresetIds.length &&
      greetingsPresetIds.length === greetingsPresetNames.length &&
      greetingsPresetNames.length
    ) {
      req.greetings = greetingsTypes.map((type, index) => {
        return {
          type: greetingsTypes[index],
          preset: {
            id: greetingsPresetIds[index],
            uri: greetingsPresetUris[index],
            name: greetingsPresetNames[index],
          },
        };
      });
    }
  }

  return req;
};

export const getDownloadRuleObj = async (res, extensionList = []) => {
  let extension = undefined;
  if (res?.extension) {
    extension = extensionList.find(element => element.id == res.extension.id);
  }

  let newObj = {
    RuleID: res.id,
    ExtensionID: extension ? extension.id : '',
    'Extension to Apply Rule To': extension ? extension?.extensionNumber : '',
    Enabled: res.enabled ? 'True' : 'False',
    Name: res.name,
    'Callers-callerId': '',
    'Callers-name': '',
    'CalledNumbers-phoneNumber': '',
    'Schedule-Ranges': '',
    'Schedule-WeeklyRanges-Monday': '',
    'Schedule-WeeklyRanges-Tuesday': '',
    'Schedule-WeeklyRanges-Wednesday': '',
    'Schedule-WeeklyRanges-Thursday': '',
    'Schedule-WeeklyRanges-Friday': '',
    'Schedule-WeeklyRanges-Saturday': '',
    'Schedule-WeeklyRanges-Sunday': '',
    'Schedule-Ref': res.schedule ? res.schedule?.ref : '',
    CallHandlingAction: res.callHandlingAction,
    'Forwarding-notifyMySoftPhones': res.forwarding
      ? res.forwarding.notifyMySoftPhones
        ? 'True'
        : 'False'
      : '',
    'Forwarding-notifyAdminSoftPhone': res.forwarding
      ? res.forwarding.notifyAdminSoftPhones
        ? 'True'
        : 'False'
      : '',
    'Forwarding-softPhonesRingCount': res.forwarding
      ? res.forwarding.softPhonesRingCount
      : '',
    'Forwarding-ringingMode': res.forwarding ? res.forwarding.ringingMode : '',
    'Forwarding-mobileTimeout': res.forwarding
      ? res.forwarding.mobileTimeout
        ? 'True'
        : 'False'
      : '',
    'Forwarding-Rules-index': '',
    'Forwarding-Rules-ringCount': '',
    'Forwarding-Rules-enabled': '',
    'Forwarding-Rules-ForwardingNumbers-uri': '',
    'Forwarding-Rules-ForwardingNumbers-id': '',
    'Forwarding-Rules-ForwardingNumbers-phoneNumber': '',
    'Forwarding-Rules-ForwardingNumbers-label': '',
    'Forwarding-Rules-ForwardingNumbers-type': '',
    'Unconditional Forwarding-phoneNumber': res.unconditionalForwarding
      ? res.unconditionalForwarding.phoneNumber
      : '',
    'Queue-transferMode': res.queue ? res.queue.transferMode : '',
    'Queue-holdAudioInterruptionMode': res.queue
      ? res.queue.holdAudioInterruptionMode
      : '',
    'Queue-holdAudioInterruptionPeriod': res.queue
      ? res.queue.holdAudioInterruptionPeriod
      : '',
    'Queue-agentTimeout': res.queue ? res.queue.agentTimeout : '',
    'Queue-wrapUpTime': res.queue ? res.queue.wrapUpTime : '',
    'Queue-holdTime': res.queue ? res.queue.holdTime : '',
    'Queue-maxCallers': res.queue ? res.queue.maxCallers : '',
    'Queue-maxCallersAction': res.queue ? res.queue.maxCallersAction : '',
    'Queue-FixedOrderAgents-Index': '',
    'Queue-FixedOrderAgents-Extension-id': '',
    'Queue-FixedOrderAgents-Extension-uri': '',
    'Queue-FixedOrderAgents-Extension-extensionNumber': '',
    'Queue-FixedOrderAgents-Extension-partnerId': '',
    'Transfer-Extension-id': res.transfer
      ? res.transfer.extension
        ? res.transfer.extension?.id
        : ''
      : '',
    'Transfer-Extension-uri': res.transfer
      ? res.transfer.extension
        ? res.transfer.extension?.uri
        : ''
      : '',
    'Transfer-Extension-extensionNumber': res.transfer
      ? res.transfer.extension
        ? res.transfer.extension?.extensionNumber
        : ''
      : '',
    'Transfer-Extension-partnerId': res.transfer
      ? res.transfer.extension
        ? res.transfer.extension?.partnerId
        : ''
      : '',
    'Voicemail-Enabled': res.voicemail
      ? res.voicemail?.enabled
        ? 'True'
        : 'False'
      : '',
    'Voicemail-Recipient-uri': res.voicemail
      ? res.voicemail.recipient
        ? res.voicemail.recipient.uri
          ? res.voicemail.recipient.uri
          : ''
        : ''
      : '',
    'Voicemail-Recipient-id': res.voicemail
      ? res.voicemail.recipient
        ? res.voicemail.recipient.id
          ? res.voicemail.recipient.id
          : ''
        : ''
      : '',
    'Greetings-Type': '',
    'Greetings-UsageType': '',
    'Greetings-Preset-uri': '',
    'Greetings-Preset-id': '',
    'Greetings-Preset-name': '',
    Screening: res.screening,
  };

  // if rule based on the number the incoming call dialed
  if (res.calledNumbers) {
    const calledNumbersArr = [];

    for (let number of res.calledNumbers) {
      calledNumbersArr.push(number.phoneNumber);
    }

    newObj['CalledNumbers-phoneNumber'] = calledNumbersArr.join(',');
  }

  // if number based on the caller id of the inbound caller
  if (res.callers) {
    const callerIdArr = [];
    const callerNameArr = [];

    for (let caller of res.callers) {
      callerIdArr.push(caller.callerId);
      callerNameArr.push(caller.name);
    }

    newObj['Callers-callerId'] = callerIdArr.join(',');
    newObj['Callers-name'] = callerNameArr.join(',');
  }

  // if rule is based off a certain schedule. weekly or for a calendar period of dates
  if (res.schedule) {
    if (res.schedule.ranges) {
      let ranges = [];
      res.schedule.ranges.forEach(range => {
        ranges.push(`${range?.from} - ${range?.to}`);
      });
      newObj['Schedule-Ranges'] = ranges.join(';\r\n ');
    }

    if (res.schedule.weeklyRanges) {
      let days = [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday',
      ];
      for (let weekDay of days) {
        if (res.schedule.weeklyRanges[weekDay]) {
          let weeklyRanges = [];
          res.schedule.weeklyRanges[weekDay].forEach(range => {
            weeklyRanges.push(`${range?.from} - ${range?.to}`);
          });
          newObj[
            `Schedule-WeeklyRanges-${weekDay.charAt(0).toUpperCase() +
              weekDay.slice(1)}`
          ] = weeklyRanges.join(';\r\n');
        }
      }
    }
  }

  //Greetings applied for an answering rule; only predefined greetings can be applied
  if (res.greetings) {
    const greetingTypes = [];
    const greetingPresetUris = [];
    const greetingPresetIds = [];
    const greetingPresetNames = [];

    for (let greeting of res.greetings) {
      if (greeting.type) {
        greetingTypes.push(greeting.type);
      }
      if (greeting.preset) {
        if (greeting.preset.uri) {
          greetingPresetUris.push(greeting.preset.uri);
        }
        if (greeting.preset.id) {
          greetingPresetIds.push(greeting.preset.id);
        }
        if (greeting.preset.name) {
          greetingPresetNames.push(greeting.preset.name);
        }
      }
    }

    newObj['Greetings-Type'] = greetingTypes.join(',');
    newObj['Greetings-Preset-uri'] = greetingPresetUris.join(',');
    newObj['Greetings-Preset-id'] = greetingPresetIds.join(',');
    newObj['Greetings-Preset-name'] = greetingPresetNames.join(',');
  }

  if (res.forwarding && res.forwarding.rules) {
    const forwaringRuleIndex = [];
    const forwaringRuleRingCount = [];
    const forwaringRuleEnabled = [];

    const forwardingRuleAllForwaringId = [];
    const forwardingRuleAllForwaringUris = [];
    const forwardingRuleAllForwaringPhone = [];
    const forwardingRuleAllForwaringLabel = [];
    const forwardingRuleAllForwaringType = [];

    for (let rule of res.forwarding.rules) {
      forwaringRuleIndex.push(rule.index);
      forwaringRuleRingCount.push(rule.ringCount);
      forwaringRuleEnabled.push(rule.enabled);

      if (rule.forwardingNumbers) {
        const forwaringRuleForwardingIds = [];
        const forwaringRuleForwardingUris = [];
        const forwaringRuleForwardingPhones = [];
        const forwaringRuleForwardingLabels = [];
        const forwaringRuleForwardingTypes = [];

        for (let forwardingNumber of rule.forwardingNumbers) {
          forwardingNumber?.id &&
            forwaringRuleForwardingIds.push(forwardingNumber.id);
          forwardingNumber?.uri &&
            forwaringRuleForwardingUris.push(forwardingNumber.uri);
          forwardingNumber?.phoneNumber &&
            forwaringRuleForwardingPhones.push(forwardingNumber.phoneNumber);
          forwardingNumber?.label &&
            forwaringRuleForwardingLabels.push(forwardingNumber.label);
          forwardingNumber?.type &&
            forwaringRuleForwardingTypes.push(forwardingNumber.type);
        }

        forwardingRuleAllForwaringId.push(forwaringRuleForwardingUris);
        forwardingRuleAllForwaringUris.push(forwaringRuleForwardingUris);
        forwardingRuleAllForwaringPhone.push(forwaringRuleForwardingUris);
        forwardingRuleAllForwaringLabel.push(forwaringRuleForwardingUris);
        forwardingRuleAllForwaringType.push(forwaringRuleForwardingUris);
      }
    }

    newObj['Forwarding-Rules-index'] = forwaringRuleIndex.join(',');
    newObj['Forwarding-Rules-ringCount'] = forwaringRuleRingCount.join(',');
    newObj['Forwarding-Rules-enabled'] = forwaringRuleEnabled.join(',');

    if (forwardingRuleAllForwaringId.length) {
      newObj[
        'Forwarding-Rules-ForwardingNumbers-id'
      ] = forwardingRuleAllForwaringId.map(item => item?.join(';'))?.join(',');
    }
    if (forwardingRuleAllForwaringUris.length) {
      newObj[
        'Forwarding-Rules-ForwardingNumbers-uri'
      ] = forwardingRuleAllForwaringUris
        .map(item => item?.join(';'))
        ?.join(',');
    }
    if (forwardingRuleAllForwaringPhone.length) {
      newObj[
        'Forwarding-Rules-ForwardingNumbers-phoneNumber'
      ] = forwardingRuleAllForwaringPhone
        .map(item => item?.join(';'))
        ?.join(',');
    }
    if (forwardingRuleAllForwaringLabel.length) {
      newObj[
        'Forwarding-Rules-ForwardingNumbers-label'
      ] = forwardingRuleAllForwaringLabel
        .map(item => item?.join(';'))
        ?.join(',');
    }
    if (forwardingRuleAllForwaringType.length) {
      newObj[
        'Forwarding-Rules-ForwardingNumbers-type'
      ] = forwardingRuleAllForwaringType
        .map(item => item?.join(';'))
        ?.join(',');
    }
  }

  if (res.queue && res.queue.fixedOrderAgents) {
    const queueFixedOrderIndex = [];
    const queueFixedOrderExtensionId = [];
    const queueFixedOrderExtensionUri = [];
    const queueFixedOrderExtensionExtensionNum = [];
    const queueFixedOrderExtensionPartnerId = [];

    for (let rule of res.queue.fixedOrderAgents) {
      queueFixedOrderIndex.push(rule.index);
      queueFixedOrderExtensionId.push(rule.extension.id);
      queueFixedOrderExtensionUri.push(rule.extension.uri);
      queueFixedOrderExtensionExtensionNum.push(rule.extension.extensionNumber);
      queueFixedOrderExtensionPartnerId.push(rule.extension.name);
    }

    newObj['Queue-FixedOrderAgents-Index'] = queueFixedOrderIndex.join(',');
    newObj[
      'Queue-FixedOrderAgents-Extension-id'
    ] = queueFixedOrderExtensionId.join(',');
    newObj[
      'Queue-FixedOrderAgents-Extension-uri'
    ] = queueFixedOrderExtensionUri.join(',');
    newObj[
      'Queue-FixedOrderAgents-Extension-extensionNumber'
    ] = queueFixedOrderExtensionExtensionNum.join(',');
    newObj[
      'Queue-FixedOrderAgents-Extension-partnerId'
    ] = queueFixedOrderExtensionPartnerId.join(',');
  }

  return newObj;
};
